import PersonalGreeting from './personalGreeting';

export default PersonalGreeting;